import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateArProfileSchema } from "@/v2/schema/ar-profile";
import { ArProfile } from "@/v2/types";

export default async function UpdateArProfile({
    id,
    data,
}: {
    id: string;
    data: CreateArProfileSchema;
}): Promise<ArProfile> {
    const res = await apiClientWithRefreshToken({
        url: `/ar-engineering-profile/${id}`,
        method: "PUT",
        data,
    });
    return res.data;
}
